module.exports = __webpack_public_path__ + "static/Product-Online-Fullframe-4.6af9fdb6.jpg";